import { render, staticRenderFns } from "./PartnerDataSheetView.vue?vue&type=template&id=635b7a9a&"
import script from "./PartnerDataSheetView.vue?vue&type=script&lang=ts&"
export * from "./PartnerDataSheetView.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerDataSheetView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports